<template>
  <div>
    <CContainer>
      <LocationRestrictionsDataTable ref="LocationRestrictionsDataTable" />
    </CContainer>
  </div>
</template>
<script>
import LocationRestrictionsDataTable from "@/v3components/Datatables/LocationRestrictionsDataTable"

import { mapGetters } from "vuex"

export default {
  name: "LimitLocationAvailability",
  components: {
    LocationRestrictionsDataTable
  },
  computed: {
    ...mapGetters({
      multiSelectStudentsList: "users/multiSelectStudentsList"
    })
  },
  methods: {
    refreshDataTable() {
      this.$refs.LocationRestrictionsDataTable.refreshDataTable()
    }
  }
}
</script>
